/**
 * @file
 * Handles space menu functionality.
 */

((_) => {
  function toggleSpaceMenu(spaceMenuToggle) {
    const isExpanded = spaceMenuToggle.classList.contains("is-expanded");
    const shouldExpand = !isExpanded;
    const shouldContract = isExpanded;
    const parent = spaceMenuToggle.closest(".js-space-menu__wrapper--primary");
    const spaceMenu = parent.querySelector("nav");

    if (shouldExpand) {
      parent.classList.remove("has-hidden-menu");
      parent.classList.add("is-expanded");
      spaceMenuToggle.classList.add("is-expanded");
      spaceMenuToggle.setAttribute("aria-expanded", "true");
      spaceMenu.style.display = "block";
    }

    if (shouldContract) {
      parent.classList.add("has-hidden-menu");
      parent.classList.remove("is-expanded");
      spaceMenuToggle.classList.remove("is-expanded");
      spaceMenuToggle.setAttribute("aria-expanded", "false");
      spaceMenu.style.display = "none";
    }
  }

  /**
   * Initializes some stuff.
   */
  function init() {
    const spaceMenuToggle = document.querySelector(".js-space-menu__toggle");

    if (spaceMenuToggle) {
      spaceMenuToggle.addEventListener(
        "click",
        _.debounce(() => {
          toggleSpaceMenu(spaceMenuToggle);
        }, 150)
      );
    }
  }

  init();
})(_);
